// axios interceptor
export default function(config) {
  const env = window.env || process.env
  return Object.assign({}, config, {
    baseURL: `${env.VUE_APP_API_HOST}/${env.VUE_APP_API_NAMESPACE}`,
  })
}
